/**
 * Debounce function to limit the rate at which a function is invoked.
 *
 * @param {number} ms - The time to wait (in milliseconds) before invoking the function.
 * @param {function} callback - The function to be debounced.
 * @returns {function} - A debounced version of the input function.
 */
export function debounce(ms, callback) {
    let timeout;

    return (...args) => {
        if (timeout) {
            clearTimeout(timeout);
        }

        timeout = setTimeout(() => {
            callback.call(null, ...args);
            timeout = null;
        }, ms);
    };
}
